import React from 'react';
import style from './notFound.module.css';
import oops from '../../../assets/imgs/oops.png'

const NotFound = () => {
    return(
        <div className={style.container}>
            <img src={oops} alt="Oops!" />
            404 Not Found
        </div>
    )
};

export default NotFound;